import confetti from 'canvas-confetti';

const BATCH_SIZE = 10;
const BASE_INTERVAL_MS = 25;
const HALF_SPREAD_BATCHES = 1;
const BASE_GRAVITY = 0.9;
const GRAVITY_RANDOM_DELTA = 0.3;

const confettiCharityRegex = /Your ".+" link was approved\. (\d+(?:\.\d+)?)\$ was added to your account\./;
const confettiGatewayRegex = /Your payment was successful, (\d+(?:\.\d+)?)\$ was added to your account\./;

class ConfettiService {
    static fire(count) {
        if (!count || count <= 0) return;

        const vw = window.innerWidth;
        const vh = window.innerHeight;

        const origins =
            count > 50
                ? [{x: 0, y: 1}, {x: 1, y: 1}]
                : [{x: 0, y: 1}];

        const target = {x: 0.5, y: 0};

        const velocity = Math.sqrt(vw * vw + vh * vh) / 18;
        const ticks = Math.max(1000, vh / 2);

        let remaining = count;
        let batchIndex = 0;
        let firedTotal = 0;

        const fireBatch = () => {
            if (remaining <= 0) return;

            const batchTotal = Math.min(BATCH_SIZE, remaining);
            remaining -= batchTotal;
            firedTotal += batchTotal;

            const perOrigin = Math.floor(batchTotal / origins.length);
            const extra = batchTotal % origins.length;

            const spreadMultiplier =
                batchIndex < HALF_SPREAD_BATCHES ? 0.5 : 1;

            const gravity = BASE_GRAVITY + (Math.random() * 2 - 1) * GRAVITY_RANDOM_DELTA;

            origins.forEach((origin, i) => {
                const dx = (target.x - origin.x) * vw;
                const dy = (target.y - origin.y) * vh;

                const angle =
                    Math.atan2(-dy, dx / 2) * (180 / Math.PI);

                const baseSpread = 90 - angle / 2;

                confetti({
                    particleCount: perOrigin + (i === 0 ? extra : 0),
                    angle,
                    spread: baseSpread * spreadMultiplier,
                    origin,
                    startVelocity: velocity,
                    gravity,
                    ticks
                });
            });

            batchIndex++;

            let interval = BASE_INTERVAL_MS;
            if (firedTotal >= 1000) interval /= 4;
            else if (firedTotal >= 500) interval /= 2;

            setTimeout(fireBatch, interval);
        };

        fireBatch();
    }

    static calculateConfettiCount(message) {
        let match =
            message?.match(confettiCharityRegex) ||
            message?.match(confettiGatewayRegex);

        return match ? Number(match[1]) : 0;
    }
}

export default ConfettiService;